/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Full_Stack_Web_Apps_Work_0_DescInputs */

const en_svc_full_stack_web_apps_work_0_desc = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A gamified engagement web app with auth, live leaderboards, and real-time updates on a battery-packed build.`)
};

const ar_svc_full_stack_web_apps_work_0_desc = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تطبيق ويب تفاعلي مرقّم بمصادقة ولوحات مقدمين مباشرة وتحديثات لحظية على بنية متكاملة.`)
};

const bn_svc_full_stack_web_apps_work_0_desc = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অথ, লাইভ লিডারবোর্ড ও রিয়েল-টাইম আপডেটসহ একটি গেমিফাইড এনগেজমেন্ট ওয়েব অ্যাপ, ব্যাটারি-প্যাকড বিল্ডে।`)
};

const de_svc_full_stack_web_apps_work_0_desc = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine spielerische Engagement-Web-App mit Authentifizierung, Live-Bestenlisten und Echtzeit-Updates in einem voll ausgestatteten Build.`)
};

const es_svc_full_stack_web_apps_work_0_desc = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una aplicación web de participación gamificada con autenticación, rankings en vivo y actualizaciones en tiempo real en un build completo.`)
};

const fr_svc_full_stack_web_apps_work_0_desc = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une application Web d'engagement gamifiée avec authentification, classements en direct et mises à jour en temps réel sur un build complet.`)
};

const pt_svc_full_stack_web_apps_work_0_desc = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um aplicativo web de engajamento gamificado com autenticação, rankings ao vivo e atualizações em tempo real em um build completo.`)
};

const zh_svc_full_stack_web_apps_work_0_desc = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`带登录、实时榜单和实时更新的游戏化互动 Web 应用，一次配齐交工。`)
};

const tr_svc_full_stack_web_apps_work_0_desc = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kimlik doğrulamalı, canlı liderlik tabloları ve gerçek zamanlı güncellemeli oyunlaştırılmış etkileşim web uygulaması, dolu dolu bir derlemede.`)
};

const ru_svc_full_stack_web_apps_work_0_desc = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Геймифицированное engagement веб-приложение с аутентификацией, живыми лидербордами и реалтайм-апдейтами в полной комплектации.`)
};

const pl_svc_full_stack_web_apps_work_0_desc = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Growa apka zaangażowania z logowaniem, żywymi rankingami i aktualizacjami w czasie rzeczywistym w kompletnej wersji.`)
};

/**
* | output |
* | --- |
* | "A gamified engagement web app with auth, live leaderboards, and real-time updates on a battery-packed build." |
*
* @param {Svc_Full_Stack_Web_Apps_Work_0_DescInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_full_stack_web_apps_work_0_desc = /** @type {((inputs?: Svc_Full_Stack_Web_Apps_Work_0_DescInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Full_Stack_Web_Apps_Work_0_DescInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_full_stack_web_apps_work_0_desc(inputs)
	if (locale === "bn") return bn_svc_full_stack_web_apps_work_0_desc(inputs)
	if (locale === "de") return de_svc_full_stack_web_apps_work_0_desc(inputs)
	if (locale === "es") return es_svc_full_stack_web_apps_work_0_desc(inputs)
	if (locale === "fr") return fr_svc_full_stack_web_apps_work_0_desc(inputs)
	if (locale === "pt") return pt_svc_full_stack_web_apps_work_0_desc(inputs)
	if (locale === "zh") return zh_svc_full_stack_web_apps_work_0_desc(inputs)
	if (locale === "tr") return tr_svc_full_stack_web_apps_work_0_desc(inputs)
	if (locale === "ru") return ru_svc_full_stack_web_apps_work_0_desc(inputs)
	if (locale === "pl") return pl_svc_full_stack_web_apps_work_0_desc(inputs)
	return en_svc_full_stack_web_apps_work_0_desc(inputs)
});
export { svc_full_stack_web_apps_work_0_desc as "svc_full-stack-web-apps_work_0_desc" }